import { gql } from "urql";
export const CreatePatientMutation = gql `
    mutation CreatePatient($input: PatientCreateInput!) {
        patients {
            createPatient(input: $input) {
                patientId
                caregiverId
                firstName
                lastName
                dateOfBirth
                postalCode
                isActive
                createdAt
            }
        }
    }
`;
export const UpdatePatientMutation = gql `
    mutation UpdatePatient($input: PatientUpdateInput!) {
        patients {
            updatePatient(input: $input) {
                patientId
                caregiverId
                firstName
                lastName
                dateOfBirth
                preferredLanguages
                daysAvailable
                timeAvailable
                postalCode
                isActive
                createdAt
                providers {
                    userId
                    firstName
                    lastName
                    imageUrl
                }
                conditionList {
                    label
                    value
                }
                insuranceList {
                    label
                    value
                }
                therapyCategoryList {
                    label
                    value
                }
                therapySubCategoryList {
                    label
                    value
                }
            }
        }
    }
`;
export const DeletePatientMutation = gql `
    mutation DeletePatient($patientId: String!) {
        patients {
            deletePatient(patientId: $patientId) {
                patientId
            }
        }
    }
`;
